import { useEffect } from "react";
import api from "../../lib/api";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SeoHead() {
  useEffect(() => {
    api.get("/seo").then(({ data }) => {
      const seo = data.seo || {};
      const geo = data.geo || {};
      if (seo.title) document.title = seo.title;
      setMeta("name", "description", seo.description);
      setMeta("name", "keywords", seo.keywords);
      setMeta("property", "og:title", seo.title);
      setMeta("property", "og:description", seo.description);
      setMeta("property", "og:image", seo.og_image);
      setMeta("property", "og:type", "website");
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:site", seo.twitter_handle);

      // JSON-LD LocalBusiness (GEO)
      const ld = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        name: geo.business_name || "Got Your Back Club",
        email: geo.email,
        telephone: geo.phone,
        address: {
          "@type": "PostalAddress",
          streetAddress: geo.street,
          addressLocality: geo.city,
          addressRegion: geo.region,
          postalCode: geo.postal_code,
          addressCountry: geo.country,
        },
        areaServed: (geo.service_areas || "").split(",").map((s) => s.trim()).filter(Boolean),
      };
      if (geo.latitude && geo.longitude) {
        ld.geo = { "@type": "GeoCoordinates", latitude: geo.latitude, longitude: geo.longitude };
      }
      let script = document.getElementById("gybc-jsonld");
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "gybc-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(ld);
    }).catch(() => {});
  }, []);
  return null;
}
